import { ISchedulesRepository } from 'shared/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisSchedulesRepository from './implementations/VectisSchedulesRepository';

let instance: ISchedulesRepository | null;

export default function makeSchedulesRepository() {
  if (!instance) {
    const provider = makeHTTPProvider();

    instance = new VectisSchedulesRepository(provider);
  }

  return instance;
}
